<template>
    <div>
        <label v-if="label">{{ label }}</label>
        <div class="row row-collapse">
            <div class="column">
                <div class="form-group">
                    <div class="input__field cu-p p-0 icon-container" v-on:click="togglePicker">
                        <span v-if="icon && icon.type === 'emoji'" class="icon--type-emoji">{{ icon.value }}</span>
                        <span v-else-if="icon && icon.type === 'svg'" v-html="icon.value" v-bind:style="{ color: icon.color }" class="icon--type-svg"></span>
                        <span v-else class="icon--placeholder"></span>
                        <input type="hidden" v-bind:name="name" v-bind:value="serializedValue" />
                    </div>
                    <div class="form-group-addon">
                        <dropdown-menu
                            v-bind:show-caret-icon="true"
                            ref="dropdown"
                            class="form-append dropdown--z-above-redactor"
                            width="auto"
                            v-bind:close-on-click="false"
                            position="dropdown-p--left translate-x--picker"
                        >
                            <span slot="trigger"></span>
                            <div class="icon-picker">
                                <div class="row">
                                    <div class="small-12 columns">
                                        <nav class="nav-tab">
                                            <a v-bind:class="{'nav-item--active': selectedTab === 'emoji'}" class="nav-item f-s-4" href="#select" v-on:click.prevent.stop="selectedTab = 'emoji'">{{ trans('Emoji') }}</a>
                                            <a v-bind:class="{'nav-item--active': selectedTab === 'icon'}" class="nav-item f-s-4" href="#select" v-on:click.prevent.stop="selectedTab = 'icon'">{{ trans('Icon') }}</a>
                                        </nav>
                                    </div>
                                </div>
                                <div v-show="true"> <!-- Container for picker -->
                                    <emoji-picker
                                        v-if="selectedTab === 'emoji'"
                                        ref="picker"
                                        class="light"
                                        style="--border-size: 0; --indicator-color: rgb(111,111,255)"
                                        v-on:emoji-click="selectEmoji($event.detail)"
                                    ></emoji-picker>
                                    <div v-if="selectedTab === 'icon'" class="icons-tab">
                                        <icon-list
                                            color="#000000"
                                            v-on:input="selectIcon"
                                        ></icon-list>
                                    </div>
                                </div>
                            </div>
                        </dropdown-menu>
                    </div>
                </div>
            </div>
            <div>
                <button v-if="showClearButton" v-on:click="clearEmoji" type="button" class="btn btn-text btn-text--muted m-l-3">{{ trans('Clear') }}</button>
            </div>
        </div>
    </div>
</template>
<script>
import DropdownMenu from '../DropdownMenu.vue';
import { EventBus } from '../../event-bus.js';

export default {
    components: {
        DropdownMenu,
        IconList: () => import('./IconList.vue')
    },
    props: {
        value: {
            type: [Object, String], // String is used when field is filled with old input after validation error
            required: false,
            default: null
        },
        name: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: false
        },
        showClearButton: {
            type: Boolean,
            required: false,
            default: true
        },
        defaultTab: {
            type: String,
            required: false,
            default: 'emoji'
        }
    },
    data() {
        return {
            icon: typeof this.value === 'string' ? JSON.parse(this.value) : this.value,
            selectedTab: this.defaultTab,
        }
    },
    computed: {
        serializedValue() {
            return JSON.stringify(this.icon);
        }
    },
    watch: {
        value(newVal) {
            this.icon = newVal;
        },
        icon: {
            deep: true,
            handler() {
                this.$emit('input', this.serializedValue);
                EventBus.$emit('form:element:changed', this.name, this.serializedValue);
            }
        }
    },
    methods: {
        selectEmoji(detail) {
            this.icon = {
                type: 'emoji',
                value: detail.unicode,
            };
            this.$refs.dropdown.closeMenu();
        },
        togglePicker(event) {
            if (this.$refs.dropdown.show === false) {
                this.$refs.dropdown.openMenu();
            } else {
                this.$refs.dropdown.closeMenu();
            }

            // We need to stop event propagation in order for clickaway not to
            // be triggered in the dropdown component
            event.stopPropagation();
        },
        clearEmoji() {
            this.icon = { type: 'emoji', value: '' };
        },
        selectIcon(icon) {
            this.icon = {
                type: 'svg',
                name: icon.name,
                value: icon.value,
                color: icon.color,
            };
            this.$refs.dropdown.closeMenu();
        },
    },
    mounted() {
        var url = 'https://cdn.jsdelivr.net/npm/emoji-picker-element@^1/index.js';

        if (document.querySelector('script[src="' + url + '"]')) {
            return;
        }

        var script = document.createElement('script');
        script.type = 'module';
        script.src = url;
        document.head.appendChild(script);
    },
}
</script>